export const LOCAL_STORAGE_CONSTANTS = {
  AUTH_TOKEN: "auth_token",
  ORIGINAL_AUTH_TOKEN: "original_auth_token",
  ACTING_AS: "acting_as",
  POSTDICOM_ACCOUNT_ID: "postdicom_accountuid",
  POSTDICOM_USER_LIST: "postdicom_user_list",
};
